import { useTranslation } from 'react-i18next'

import type { Participant } from 'livekit-client'

import { initialsOf } from './ParticipantTile'
import styles from './medentee.module.css'

const OVERFLOW_FACES = 3

export type OverflowTileProps = {
  participants: Participant[]
}

export function OverflowTile({ participants }: OverflowTileProps) {
  const { t } = useTranslation()

  return (
    <div className={styles.overflowTile}>
      <div className={styles.overflowFaces}>
        {participants.slice(0, OVERFLOW_FACES).map((participant) => (
          <span key={participant.sid} className={styles.overflowFace}>
            {initialsOf(participant.name || participant.identity)}
          </span>
        ))}
      </div>
      <span className={styles.overflowLabel}>
        {t('chat.call.grid.overflowTile', { count: participants.length })}
      </span>
    </div>
  )
}
